import React, { Component } from "react";
import { uniq, map, flatten } from "lodash";
import moment from "moment";

class Format extends Component {
  static Countries(devices) {
    return uniq(map(devices, "country")).sort();
  }
  static Customers(devices, country) {
    if (country == null) return uniq(map(devices, "customerName")).sort();
    return uniq(
      map(
        devices.filter((obj) => obj.country === country),
        "customerName"
      )
    ).sort();
  }
  static Users(users, user) {
   // console.log(users, user);
    if (user == null) return uniq(map(users, "displayName")).sort();
    return uniq(
      map(
        users.filter((obj) => obj.users === user),
        "displayName"
      )
    ).sort();
  }
  static DeviceIDsByDeviceType(devices, devicetypes) {
    if (devicetypes.length == 0) return [];
    return uniq(
      map(
        devices.filter((obj) => devicetypes.includes(obj.deviceFull)),
        "deviceID"
      )
    ).sort();
  }
  static findDeviceName(devices, deviceWithSerial, seriesType) {
    for (var i = 0; i < devices.length; i++) {
      if (devices[i].deviceWithSerial == deviceWithSerial) {
        if (seriesType == "Device Name") {
          return devices[i].deviceName;
        } else if (seriesType == "Device Name + Device Size + Version") {
          return devices[i].deviceFull;
        }
      }
    }
  }
  static DevicesWithSerial(devices, customer) {
    let devicesWithSerial = [];
    if (customer == null) {
      devicesWithSerial = uniq(
        map(
          devices.filter((obj) => obj.customerName),
          "deviceWithSerial"
        )
      ).sort();
    } else {
      devicesWithSerial = uniq(
        map(
          devices.filter((obj) => obj.customerName === customer),
          "deviceWithSerial"
        )
      ).sort();
    }
    return devicesWithSerial;
  }

  static DevicesWithSerialByCadids(devices, cadids) {
    //console.log(cadids);
    let devicesWithSerial = [];
    if (cadids == null) {
      return [];
    } else {
      devicesWithSerial = uniq(
        map(
          devices.filter(
            (obj) => cadids.indexOf(obj.customerAssemblyDeviceID) > -1
          ),
          "deviceWithSerial"
        )
      ).sort();
    }
    return devicesWithSerial;
  }
  static cadidByDeviceWithSerial(devices, deviceWithSerial) {
    var d = devices.filter((obj) => obj.deviceWithSerial === deviceWithSerial);
    //console.log(d, devices, deviceWithSerial);
    return d[0].customerAssemblyDeviceID;
  }
  static Assemblys(devices, country, customer) {
    if (country == null && customer == null)
      return uniq(map(devices, "mainMachineSerialNo")).sort();
    if (customer == null) {
      return uniq(
        map(
          devices.filter((obj) => obj.country === country),
          "mainMachineSerialNo"
        )
      ).sort();
    } else if (country == null) {
      return uniq(
        map(
          devices.filter((obj) => obj.customerName === customer),
          "mainMachineSerialNo"
        )
      ).sort();
    } else {
      return uniq(
        map(
          devices.filter(
            (obj) => obj.customerName === customer && obj.country == country
          ),
          "mainMachineSerialNo"
        )
      ).sort();
    }
  }
  static Devices(devices, customer) {
    if (customer == null) return [];

    return uniq(
      map(
        devices.filter((obj) => obj.customerName === customer),
        "deviceLabel"
      )
    ).sort();
  }
  static DeviceTypes(devices, deviceType) {
    if (deviceType == "Device Name") {
      return uniq(map(devices, "deviceName")).sort();
    } else if (deviceType == "Device Name + Version") {
      return uniq(map(devices, "deviceNameVersion")).sort();
    } else if (deviceType == "Device Name + Device Size + Version") {
      return uniq(map(devices, "deviceFull")).sort();
    }
    return [];
  }
  static findDeviceLabel(devices, label, seriesType) {
    for (var i = 0; i < devices.length; i++) {
      if (devices[i].deviceLabel == label) {
        if (seriesType == "Device Name") {
          return devices[i].deviceName;
        } else if (seriesType == "Device Name + Device Size + Version") {
          return devices[i].deviceFull;
        }
      }
    }
  }
  static GetHeaderUnit(header, headers) {
    for (var i = 0; i < headers.length; i++) {
      if (headers[i].description == header) {
        if (header.includes("temperature")) return "deg";
        return headers[i].unit;
      }
    }
    return "";
  }
  static seriesParameters(devices, label, seriesType) {
    if (seriesType == "Device Name") {
      var obj = {};
      obj.versionNumber = "";
      obj.deviceSize = "";
      obj.deviceName = label;
      obj.customerAssemblyDeviceID = "";
      obj.name = label;
      return obj;
    } else if (seriesType == "Device Name + Version") {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceNameVersion == label) {
          var obj = {};
          obj.versionNumber = devices[i].versionNumber;
          obj.deviceSize = "";
          obj.deviceName = devices[i].deviceName;
          obj.customerAssemblyDeviceID = "";
          obj.name = label;
          return obj;
        }
      }
    } else if (seriesType == "Device Name + Device Size + Version") {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceFull == label) {
          var obj = {};
          obj.versionNumber = devices[i].versionNumber;
          obj.deviceSize = devices[i].deviceSize;
          obj.deviceName = devices[i].deviceName;
          obj.customerAssemblyDeviceID = "";
          obj.name = label;
          return obj;
        }
      }
    } else {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].deviceLabel == label) {
          var obj = {};
          obj.versionNumber = "";
          obj.deviceSize = "";
          obj.deviceName = "";
          obj.name = label;
          obj.customerAssemblyDeviceID = devices[i].customerAssemblyDeviceID;
          return obj;
        }
      }
    }
  }
  static GetDeviceByCADID(devices, cadid) {
    if (Array.isArray(cadid)) cadid = cadid[0];
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].customerAssemblyDeviceID == cadid) {
        return devices[i];
      }
    }
  }
  static GetDeviceItemsByCADIDs(devices, cadids) {
    let deviceItems = [];
    for (let i = 0; i < devices.length; i++) {
      if (cadids.indexOf(devices[i].customerAssemblyDeviceID) > -1) {
        deviceItems.push({
          text: devices[i].deviceFull,
          id: devices[i].customerAssemblyDeviceID,
        });
      }
    }
    return deviceItems;
  }
  static DeviceObjs(devices, machine) {
    if (machine == null) return [];
    return devices.filter((obj) => obj.mainMachineSerialNo === machine);
  }
  static getCadIds(deviceItems) {
    const cadids = [];
    for (let i = 0; i < deviceItems.length; i++) {
      cadids.push(Number(deviceItems[i].id));
    }
    return cadids;
  }
  static getDeviceItems(devices, mainMachineSerialNo) {
    const deviceItems = [];
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].mainMachineSerialNo == mainMachineSerialNo) {
        deviceItems.push({
          text: devices[i].deviceFull,
          id: devices[i].customerAssemblyDeviceID,
        });
      }
    }
    return deviceItems;
  }

  static getDeviceItemsByLabel(devices, mainMachineSerialNo, deviceLabel) {
    const deviceItems = [];
    const getItems = (dl) => {
      for (let i = 0; i < devices.length; i++) {
        if (dl == null) {
          if (devices[i].mainMachineSerialNo == mainMachineSerialNo) {
            deviceItems.push({
              text: devices[i].deviceFull,
              id: devices[i].customerAssemblyDeviceID,
            });
          }
        } else {
          if (
            devices[i].mainMachineSerialNo == mainMachineSerialNo &&
            devices[i].deviceFull == dl
          ) {
            deviceItems.push({
              text: devices[i].deviceFull,
              id: devices[i].customerAssemblyDeviceID,
            });
          }
        }
      }
    };
    if (Array.isArray(deviceLabel)) {
      deviceLabel.forEach((label) => {
        getItems(label);
      });
    } else {
      getItems(deviceLabel);
    }
    return deviceItems;
  }
  static getDeviceFull(devices, mainMachineSerialNo) {
    let deviceFullArray = [];
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].mainMachineSerialNo == mainMachineSerialNo) {
        deviceFullArray.push(devices[i].deviceFull);
      }
    }
    return deviceFullArray;
  }
  static GetSubDevices(devices, mainMachineSerialNo) {
    for (let i = 0; i < devices.length; i++) {
      if (
        devices[i].mainMachineSerialNo == mainMachineSerialNo &&
        devices[i].deviceName == "Storage Station Manual"
      ) {
        return devices[i].reportSubDeviceIDs;
      }
    }
    return [];
  }
  static getUniqDataFilteredBy(data, filter) {
    let results = uniq(map(data, filter)).sort();
    results = results.filter((el) => {
      return el !== null;
    });
    return results;
  }
  static getIconPath(dataType) {
    switch (dataType) {
      case "alarms":
        return "../assets/images/ic_alarm_30px_red.png";
      case "triggers":
        return "../assets/images/ic_triggers_30px_wbg.png";
      case "manualOperations":
        return "../assets/images/ic_manual_operation_30px_darkgrey.png";
      default:
        return "../assets/images/generic.png";
    }
  }
  static GetCustomerByCustomerID(devices, customerID) {
    if (customerID == null) return null;
    const customer = uniq(
      map(
        devices.filter((obj) => obj.customerID === customerID),
        "customerName"
      )
    );
    if (customer.length == 1) {
      return customer[0];
    }
    return null;
  }
  static GetCustomerByCadID(devices, cadid) {
    if (cadid == null) return null;
    for (let i = 0; i < devices.length; i++) {
      if (devices[i].customerAssemblyDeviceID == cadid) {
        return devices[i].customerName;
      }
    }
  }
  static GetCustomerByAssembly(devices, mainMachineSerialNo) {
    if (mainMachineSerialNo == null) return null;
    const customer = uniq(
      map(
        devices.filter(
          (obj) => obj.mainMachineSerialNo === mainMachineSerialNo
        ),
        "customerName"
      )
    );
    if (customer.length == 1) {
      return customer[0];
    }
    return null;
  }

  static GetAssemblyByCadID(devices, cadid) {
    if (cadid == null) return null;
    const assembly = uniq(
      map(
        devices.filter((obj) => obj.customerAssemblyDeviceID == cadid),
        "mainMachineSerialNo"
      )
    );
    if (assembly.length == 1) {
      return assembly[0];
    }
    return null;
  }

  static GetCountryByCADID(devices, cadid) {
    if (cadid == null) return null;
    const country = uniq(
      map(
        devices.filter((obj) => obj.customerAssemblyDeviceID === cadid),
        "country"
      )
    );
    if (country.length == 1) {
      return country[0];
    }
    return null;
  }
  static addSelectedDateParams(selectedDate, newParams, subscribed) {
    if (selectedDate != null && subscribed) {
      newParams.start = selectedDate;
      newParams.end = selectedDate;
    }
    return newParams;
  }
  static GetAllBySearchPhrase(events, searchPhrase) {
    if (searchPhrase == null || searchPhrase == "") return events;

    let filters = events.filter((item) => {
      let match = false;
      for (const property in item) {
        if (item[property] != null) {
          if (
            item[property]
              .toString()
              .toLocaleLowerCase()
              .indexOf(searchPhrase.toLocaleLowerCase()) >= 0
          ) {
            match = true;
          }
          if (
            moment(item[property]).format("MM-DD-YYYY") &&
            moment(item[property]).format("MM-DD-YYYY").indexOf(searchPhrase) >=
              0
          ) {
            match = true;
          }
        }
      }
      return match;
    });
    return filters;
  }
}

export default Format;
